module.exports = __webpack_public_path__ + "static/3-bfd61dd05170b47261c4be94392d64c1.jpg";